import { View, Text, StyleSheet } from "@react-pdf/renderer";
import type { PdfWidgetSnapshot } from "../pdfTypes";
import type { PdfRect } from "../pdfLayout";

const s = StyleSheet.create({
  cell: {
    position: "absolute",
    borderWidth: 1,
    borderColor: "#e8e8e8",
    borderRadius: 4,
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  titleWrap: { justifyContent: "center", alignItems: "center" },
  titleText: { fontWeight: 700, color: "#1a1a1a", textAlign: "center" },
});

export function renderTitle(
  snapshot: Extract<PdfWidgetSnapshot, { type: "title" }>,
  rect: PdfRect,
  _scale: number,
) {
  const text = snapshot.title ?? "";
  // Height drives the size, but cap it so the full title fits the cell width —
  // the cell clips overflow, so a too-wide font would otherwise be truncated with
  // an ellipsis. Bold sans-serif averages ~0.6em per char; reserve a little padding.
  const heightFont = rect.height * 0.55;
  const widthFont = text.length > 0 ? (rect.width * 0.92) / (text.length * 0.6) : heightFont;
  const fontSize = Math.min(heightFont, widthFont);
  return (
    <View style={[s.cell, s.titleWrap, { left: rect.left, top: rect.top, width: rect.width, height: rect.height }]}>
      <Text style={[s.titleText, { fontSize }]}>{text}</Text>
    </View>
  );
}
